<template>
  <div
    class="preview-coming-soon-cell"
    @mouseenter.prevent="playVideo"
    @mouseleave.prevent="stopVideo"
  >
    <instant-player
      :content-id="contentId"
      :content-type="contentType"
      :target-age="targetAge"
      :is-play-video="isPlayVideo"
      @on-click-player="handleClickPlayer"
    >
      <template #cell-component>
        <ComingSoonCell :cell-info="cellInfo" :thumbnail-info="thumbnailInfo" />
      </template>
    </instant-player>
  </div>
</template>
<script setup>
  import { ref } from 'vue'
  import ComingSoonCell from '@/components/model/cell/ComingSoonCell.vue'
  import InstantPlayer from '@/components/model/cell/instant-player/InstantPlayer.vue'
  import { CellEventMapper } from '@/common/utils/gnb.fp'
  import { useCell } from '@/common/use/useCell'

  const props = defineProps({
    cellInfo: {
      type: Object,
      default: null,
    },
    thumbnailInfo: {
      type: Object,
      default: null,
    },
  })

  const { targetAge, goDetail } = useCell(props.cellInfo)

  const isPlayVideo = ref(false)
  const contentType = ref('')
  const contentId = ref('')

  const playVideo = () => {
    isPlayVideo.value = true
  }
  const stopVideo = () => {
    isPlayVideo.value = false
  }

  const handleClickPlayer = () => {
    goDetail(props.cellInfo)
  }

  const init = () => {
    const { onInstantPlay } = CellEventMapper(props.cellInfo?.event_list)

    contentType.value = onInstantPlay?.contenttype || ''
    contentId.value = onInstantPlay?.contentid || ''
  }

  init()
</script>
<style scoped lang="scss">
  .preview-coming-soon-cell {
    height: 289px;
    .instant-player-cell {
      &.playing {
        ::v-deep(.thumbnail-area-wrap) {
          .thumb-image {
            opacity: 1;
            transition: opacity 0.5s linear 0.5s;
            .picture-area {
              transition: opacity 0.5s linear 0.5s;
              opacity: 0;
            }
          }
        }
      }
      ::v-deep(.video-area-wrap) {
        border-radius: 12px;
        overflow: hidden;
        height: 229px;
      }
      ::v-deep(.w-button-mute) {
        top: calc(229px - 30px - 10px);
        right: 10px;
      }
    }
  }
</style>
